/**
 * ChatDAGRAGDAG C2.1 sp3 — pure mappings between the fork tree-view and the
 * lens. Kept pure (no React/api) so they're unit-testable off the Vite
 * import.meta chain; ConversationInterface wires them to the live LensContext.
 */

/** Default tree expansion rides the lens: canopy = expanded, else collapsed. */
export function forksExpandedFromLens(mode: string | undefined): boolean {
  return mode === 'canopy';
}

/** Selecting a fork branch focuses that persona's trail — the existing
 *  resolveWriteTarget machinery then targets it (no second selector). */
export function forkFocusLens(personaId: string): { mode: 'single'; activePersonaIds: Set<string> } {
  return { mode: 'single', activePersonaIds: new Set([personaId]) };
}
